export const styles = {
  root: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
};
